import axios from "axios";
import { PhoneCall } from "lucide-react";
import Reveal from "@/components/Reveal";
import { DEALERSHIP } from "@/data/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MissedCall() {
  const trackTap = () => {
    axios.post(`${API}/track/missed-call`).catch(() => {});
  };

  return (
    <section data-testid="missed-call-strip" className="relative bg-[#FFFFFF] overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10 sm:py-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <Reveal>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-black/60">Zero Cost · Zero Waiting</p>
          <h2 className="mt-2 font-display font-extrabold text-2xl sm:text-3xl text-black tracking-tight">
            Give a missed call. We call you back.
          </h2>
          <p className="mt-2 text-sm text-black/70 max-w-md">
            Ring us and hang up — our sales team will call you back within minutes, on us.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <a
            data-testid="missed-call-button"
            href={`tel:${DEALERSHIP.phoneRaw}`}
            onClick={trackTap}
            className="inline-flex items-center gap-3 bg-[#05141F] hover:bg-black text-white font-display font-bold text-xl sm:text-2xl px-8 py-4 clip-notch transition-colors duration-300 whitespace-nowrap"
          >
            <PhoneCall size={22} className="text-[#FFFFFF]" />
            {DEALERSHIP.phone}
          </a>
        </Reveal>
      </div>
    </section>
  );
}
